module.exports = "app-touchspin {\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  width: 80% !important; }\n\n.btn-touchspin {\n  right: 5px;\n  position: absolute; }\n\n.item-inversionistas.childs {\n  margin-left: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas-grupos/catalogo-obras-inversionistas-grupos.component.scss
// module id = ./src/app/components/catalogo-obras/catalogo-obras-inversionistas/catalogo-obras-inversionistas-grupos/catalogo-obras-inversionistas-grupos.component.scss
// module chunks = main